import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildFleetQuery } from '../_shared/utils/fleet-query';


@Injectable({
  providedIn: 'root'
})
export class FleetChargingInsightsService {

  constructor(private readonly httpClient: HttpClient) { }

  getChargedEnergyFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'current-charging-insights-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

}
